import * as Sentry from "@sentry/react";

const isProduction = process.env.NODE_ENV === "production";

const tracePropagationTargets = [/^https?:\/\/localhost(?::\d+)?/];
if (process.env.REACT_APP_NEX_BACKEND) {
  tracePropagationTargets.push(process.env.REACT_APP_NEX_BACKEND);
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  release: process.env.REACT_APP_VERSION,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  tracesSampleRate: isProduction ? 0.2 : 1.0,
  tracePropagationTargets,
  replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});
